import React from "react";


import Appointment from '../estimates/appointment';
import SectionLoading from '../common/SectionLoading';
import { logUI } from "../../api/andyliticsApi";

const Appointments = props => {
    const now = new Date();
    
    let hasAppointmentsToDisplay = false;
    /*useEffect(() => {
        const patientId = props.currentMyChartUser;
        
        props.getAppointments(patientId);
    }, [props.currentMyChartUser]);*/
    let orderAppts = props.appointments.map(el => ({ ...el }));
    if (!props.past) { orderAppts.reverse();}
    let myAppointments = orderAppts.map(apt => {
        const aptDt = new Date(apt.dateOfService);
        const quoteAmount = apt.quoteAmount || '';
        if (props.past && (aptDt < now) && quoteAmount !='') hasAppointmentsToDisplay = true;
        else if (!props.past && (aptDt >= now) && quoteAmount != '') hasAppointmentsToDisplay = true;//patientId === "860038235"
        return <Appointment key={apt.messageId } past={props.past} appointment={apt} />;
    });


  
    try {
        return <React.Fragment>{
            hasAppointmentsToDisplay ?
                myAppointments :
                <div className="row">
                    <div className="col-12">
                        {props.past ? <div>Your available estimates for past appointments are saved here.</div> : <div>Your available estimates for scheduled appointments are saved here.</div>}
                    </div>
                </div>
        }
            {props.loaded ? <React.Fragment></React.Fragment>: <div className="estimates-loading"><SectionLoading /></div>}
        </React.Fragment>;
    } catch (e) {
        //console.error('appointments exectpion', e);
        logUI("MBHWeb.UI.Estimates.appointments", new Date(), `myEstimates/`, props, 'ERROR', e.message); 
        return <React.Fragment>{ e}</React.Fragment>;
    }
}



export default Appointments;